<template>
    <div id="Banner">
        <a-carousel dot-position="bottom" autoplay arrows>
            <div slot="prevArrow"
                 slot-scope="props"
                 class="custom-slick-arrow"
                 style="left: 10px;zIndex: 1"
            >
                <a-icon type="left-circle"/>
            </div>
            <div slot="nextArrow" slot-scope="props" class="custom-slick-arrow" style="right: 10px">
                <a-icon type="right-circle"/>
            </div>
<!--            <div class="banner_content" v-for="(item , index) in bgImages" :key="index">-->
<!--                <img :src="item" alt="">-->
<!--            </div>-->
            <div class="banner_content" >
                <div class="bgImg1"></div>
            </div>
            <div class="banner_content" >
                <div class="bgImg2"></div>
            </div>
            <div class="banner_content" >
                <div class="bgImg3"></div>
            </div>

        </a-carousel>
    </div>
</template>

<script>
    export default {
        name: "Banner",
        data() {
            return {
                bgImages: [
                    require('../assets/image/bg_1.jpg'),
                    require('../assets/image/bg_2.jpg'),
                    require('../assets/image/bg_3.jpg'),
                ]
            }
        },
        destroyed() {
        },
        created() {
        },
        methods: {}
    }
</script>

<style scoped>
    ::-webkit-scrollbar {
        display: none;
    }

    #Banner {
        width: 100%;
        height: 400px;
    }
    .banner_content{
        width: 100%;
        height: 400px;
        z-index: 12;
    }
    .bgImg1{
        width: 100%;
        height: 100%;
        background:url("../assets/image/bg_1.jpg") no-repeat;
        background-size: 100% 100%;
    }
    .bgImg2{
        width: 100%;
        height: 100%;
        background:url("../assets/image/bg_2.jpg") no-repeat;
        background-size: 100% 100%;
    }
    .bgImg3{
        width: 100%;
        height: 100%;
        background:url("../assets/image/bg_3.jpg") no-repeat;
        background-size: 100% 100%;
    }
    .banner_content > img{
        width: 100%;
        height: auto;
    }
    .ant-carousel >>> .slick-slide {
        text-align: center;
        line-height: 400px;
        background: #364d79;
        overflow: hidden;
        width: 100%;
        height: 400px;
        z-index: 999;
    }

    .ant-carousel >>> .custom-slick-arrow {
        width: 25px;
        height: 25px;
        font-size: 25px;
        color: #fff;
        background-color: rgba(31, 45, 61, 0.11);
        opacity: 0.3;
    }

    .ant-carousel >>> .custom-slick-arrow:before {
        display: none;
    }
    .ant-carousel >>> .custom-slick-arrow:hover {
        opacity: 0.8;
    }

    .ant-carousel >>> .slick-slide h3 {
        color: #fff;
    }
</style>
